module.exports = __webpack_public_path__ + "img/export_group.c7f770e9.svg";